import { useEffect, useState } from "react"
import usaFlag from "../../assets/flags/united-states.png"
import mexicoFlag from "../../assets/flags/mexico.png"
import { CONFIG_SETTINGS } from "../../config"
import moment from "moment"
import qs from 'query-string'
import uszipcodes from '../../utils/uszipcodes.json'
import { REGISTRATION_STEPS } from '../../utils/enums'
import { v4 as uuid } from 'uuid';

import axios from 'axios'

import { isFormValid, onGetFormData, onInitFormFromOrigin, onSetErrorsToForm } from "../../utils/forms";
import { removeAuthorizationHeader, updateAuthorizationHeader } from "../../utils/general"
import { useLocation, useNavigate } from "react-router"
import { private_server, services_server, onboarding_server } from "../../utils/axios"
import { useAuthContext } from "../../auth/useAuthContext"
import { getRecaptchaV3Token } from "../../utils/recaptchaV3"
import parsePhoneNumber from 'libphonenumber-js'

const phoneCountryCodesCat = [
    { label: "+1", value: "1", img: usaFlag, countryCode: 'US'},
    { label: "+52", value: "52", img: mexicoFlag, countryCode: 'MX'},
]

/*const firebaseConfig = {
    apiKey: "AIzaSyCdvkSH__1-YPHW2lXIJqdIH4EPmXdU-cE",
    authDomain: "casino-cms-7c2a9.firebaseapp.com",
    projectId: "casino-cms-7c2a9",
    storageBucket: "casino-cms-7c2a9.appspot.com",
    messagingSenderId: "525470178958",
    appId: "1:525470178958:web:a899bc77dbb140c59cb3df"
};*/

const transactionID = uuid()


//const app = initializeApp(firebaseConfig);
//const db = getFirestore(app);

const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}
/**
 * @module Layouts/Registration/useRegistration
 * @description The `useRegistration` function is a hook service that has the logic of the Registration Layout
 * 
*/

/**
 * @function onUpdateView
 * @description The code is defining an `onUpdateView` function that takes a parameter `_view` and
 * sets the state of `view` to the value of `_view` using the `setView` function. This code is
 * likely part of a React component and is used to update the view based on some user
 * interaction or other event. 
 * @param _view - Value of the view to update
 * 
*/

/**
 * @function onResetForm
 * @description The code is defining a function called `onResetForm` which resets the registration
        form to its initial state. It sets the view to the phone number request step, sets the form
        data to its initial state, clears any error messages, and sets the sending flag to false. 
*/

/**
 * @function onGetCardholerInfo
 * @description The code defines an asynchronous function called `onGetCardholerInfo` that sends a GET
 * request to an endpoint `/info` on a server using Axios library. The request includes a
 * parameter `transactionUuid` with a value generated by calling the `uuid()` function. The
 * function then waits for the response from the server and assigns the response data to a
 * variable called `info`. Finally, the function returns the `info` variable.
 * @return {Object} - Cardholder information
*/


/**
 * @function onUpdateCode
 * @description The code is an asynchronous function that is executed when a module is initialized. It
 * first waits for 1 second using the `sleep` function. Then it parses the query parameters
 * from the current URL using the `qs` library. If a `uuid` parameter is present, it sets the
 * `CasinoUUID` state variable to its value and sends a validation request to the server using
 * the `onboarding_server` object. If a `playerId` parameter is present, it sets the `PlayerID`
 * state variable to its value.
 * @param {Object} location - Get the current URL of the client and its parameters
*/

/**
 * @function onUpdateCode
 * @description The code is defining an `onUpdateCode` function that takes in a parameter `_data`.
 * Within the function, it sets the state of `phoneCode` to the value of `_data` using the
 * `setPhoneCode` function. It also sets the `error` state to `null` using the `setError`
 * function. This code is likely part of a React component and is used to update the state of
 * the component when a user enters or updates a phone code value. 
 * @param _data - The new value that contains a certain code
 * 
*/

/**
 * @function onUpdateAgreement
 * @description Handles actions to do with the selected Agreement Document, such as view the 
 * corresponding file or if the user accepted the agreement item.
 * @param _data - The update object of the selected agreement
 * @param pos - The position of the element inside the array
 * @param type - If type is equal to 'view', the function opens a modal to see the document, otherwise updates
 * only the agreement
 * 
*/

/**
 * @function onChangeForm
 * @description The code is a function that handles the onChange event of a form input field. It
 * updates the state of the form based on the user input and performs some validations on
 * specific fields such as the social security number, zip code, phone number, and birth date.
 * It also sets the loading and sending states to false and updates the form state with the new
 * data.
 * @param data - The corresponding item inside a form to be updated
 * 
*/

/**
 * @function onKeyPress
 * @description The code is defining an event handler function for the `onKeyPress` event in a React
 * component. When a key is pressed, the function checks if the key pressed is the "Enter" key.
 * If it is, the `onSubmit` function is called. This is commonly used in forms to submit the
 * form when the user presses the "Enter" key..
 * @param event - The value of the key pressed
 * 
*/

/**
 * @function onSearchAddressInfo
 * @description The code is defining a function called `onSearchAddressInfo` that takes a parameter
 * `zip`. The function searches for an object in an array called `zipcodeCats` that has a
 * property `zip` equal to the `zip` parameter passed to the function. If a matching object is
 * found, it is returned. If not, `undefined` is returned. The `uszipcodes` object is optional
 * and if it is not defined, an empty array is used as a fallback. The commented out
 * `console.log` statement is used for debugging purposes.
 * @param zip - ZIP code value
 * 
*/

/**
 * @function onChangeRecaptcha
 * @description The code is defining an arrow function called `onChangeRecaptcha` which logs a message
 * to the console and checks if the value of a `captcha` reference is truthy. If the value is
 * truthy, it sets the state of `validCaptcha` to `true`.
 * @param captcha - Catcha value from Google Recaptcha
 * 
*/

/**
 * @function onSendSMSv2
 * @description The code is a JavaScript React function called `onSendSMSv2` that sends an SMS access
 * code to a given phone number. It first gets the form data and constructs a payload object
 * with the phone number and a unique transaction UUID. It then sends a POST request to an API
 * endpoint with the payload and API key headers. If the response status is 400 or 404, it sets
 * an error message and stops sending. If the response status is 0, it sets the view to a SMS
 * request step. Finally, it sets the sending state to false..
 * @param form - Form with the cellphone number to send the SMS
 * 
*/

/**
 * @function onRequestUserData
 * @description The code is defining an asynchronous function called `onRequestUserData` that sends a
 * request to an onboarding server to retrieve user information. If the user has cardholder
 * data, the function extracts relevant information such as name, address, email, and social
 * security number, and initializes a form with this information. The function also sets the
 * maximum age for the user based on constraints specified in the user's enrollment data.
 * 
*/

/**
 * @function onValidateSMSCodev2
 * @description The code is a function in JavaScript React that is used to validate a SMS code entered
 * by a user during a registration process. It sends a request to a server with the user's
 * phone number and the code entered, and if the code is valid, it proceeds to the next step of
 * the registration process. The function also checks if the user has already enrolled, if
 * there is a pin validation required, if there are agreements that need to be accepted, and
 * sets the next view accordingly. If there is an error, it sets an error message and prompts
 * the user to try again.
 * @param form - Form with the cellphone number to send the SMS
 * @param phoneCode - The user's code value obtained from the phone number
 * 
*/

/**
 * @function onRequestDocuments
 * @description The code is defining an asynchronous function called `onRequestDocuments` that sends a
 * GET request to an endpoint `/cat/agreement` on a server using the `onboarding_server`
 * object. The function takes no arguments. The request includes a query parameter
 * `transactionUuid` with a value generated by calling the `uuid()` function.
 * 
*/

/**
 * @function onValidateDocuments
 * @description The code is defining an asynchronous function called `onValidateDocuments`. This 
 * function is used to validate and send agreements for a cardholder.
 * @param agreementCollections - The agreement collection array
 * 
*/

/**
 * @function onCheckAddress
 * @description The code is a JavaScript React function that handles the process of checking and
 * validating an address form. It first checks if all required fields are filled, and if not, it
 * sets an error message and returns. If the required fields are filled, it checks if the
 * address contains "PO BOX" or "P.O. BOX", and if it does, it sets an error message and
 * returns. If the address is valid, it sends a GET request to a server API endpoint with the
 * address information, and if the response is successful, it sets the retrieved address data to
 * a state variable.
 * @param form - The form variable with the following parameters 'street_line_one', 'zip_code', 'city', 'state',
 * 'first_name', 'surname', 'birth_date', 'ssn', 'email', 'sex_id'
 * 
*/

/**
 * @function onEnrollCardholder
 * @description The code is a function called `onEnrollCardholder` that is being defined in JavaScript
 * React. It's main purpose is to enroll a new cardholder to the corresponding program, and if the
 * server response throws an error, this function handles the error to show the end user the reason
 * of rejection or if an error exist during the process.
 * @param form - The form with complete data of the cardholder
 * @param smartyAddress - Smarty Address Data
 * 
*/

/**
 * @function onResetError
 * @description The code is defining a function called `onResetError` that sets the value of the
 * `error` variable to `null`. This function is likely used to reset or clear any error
 * messages that may have been previously displayed. 
 * 
*/

/**
 * @function onUpdateModalStatus
 * @description The code is defining an arrow function called `onUpdateModalStatus` that takes two parameters
 * `_key` and `_value`. Inside the function, it is using the `setModals` function to update the state
 * of the `modals` object. The `setModals` function is a state updater function provided by React's
 * `useState` hook. It takes an object as an argument and merges it with the current state of the
 * `modals` object. The object being merged is created using the spread operator (`...`) to copy the
 * existing properties of the `modals` object
 * @param {String} _key - The key of the modal to update
 * @param {Boolean} _value - The status value
*/


const useRegistration = (props) => {

    const history = useNavigate()
    const location = useLocation()
    //const authManager = useAuth()
    const authManager = {}
    const {login} = useAuthContext()

    

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)

    const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))
    const [cards, setCards] = useState([])
    const [modals, setModals] = useState({
        success:false,
        address_adjustment:false,
        document:false,
        uuid_error:false
    })
    const [cardholderData, setCardholder] = useState()
    const [casino_uuid, setCasinoUUID] = useState('') //568DD9A5-2394-41AC-BD9E-955D190898EC
    const [valid_captcha, setValidCaptcha] = useState(false)
    const [view, setView] = useState(REGISTRATION_STEPS.PHONENUMBER_REQUEST)
    const [playerID, setPlayerID] = useState(null)

    const [steps, setSteps] = useState([
        {value:REGISTRATION_STEPS.CASINO_PIN, label: 'Phone Number'},
        {value:REGISTRATION_STEPS.SMS_REQUEST, label: 'SMS'},
        {value:REGISTRATION_STEPS.CASINO_PIN, label: 'Pin Validation'},
        {value:REGISTRATION_STEPS.TERMS_CONDITION, label: 'Terms & Conditions'},
        {value:REGISTRATION_STEPS.USER_FORM, label: 'Personal Data'},
        {value:REGISTRATION_STEPS.SUCCESS, label: 'Success'}
    ])

    const [phoneCode, setPhoneCode] = useState('')

    const [maxAge, setMaxAge] = useState(18)

    const [agreementCollections, setAgreementCollections] = useState([
        //{id:1, version:'1.0', url:'https://www.flexiapayments.com', accepted:false, visited:false, description:'Electronic Signature Consent'},
        //{id:2, version:'1.0', url:'https://www.flexiapayments.com', accepted:false, visited:false, description:'Flexia Terms and Conditions'},
        //{id:3, version:'1.0', url:'https://www.flexiapayments.com', accepted:false, visited:false, description:'Flexia Privacy Policy'},
    ])
    const [issuer_statement, setIssuerStatement] = useState('')
    const [document, setDocument] = useState()

    const [smartyAddresses, setSmartyAddresses] = useState(JSON.parse(JSON.stringify(fakeAddresses)))

    /*
    The code is using the `useEffect` hook in a React component to call the `onInitModule`
    function from the `actions` object when the component mounts. The empty array `[]` passed as the
    second argument to `useEffect` ensures that the effect is only run once, on mount. */
    useEffect(() => {
        actions.onInitModule()
    }, [])

    /* reCAPTCHA v3 es invisible (sin checkbox): se ejecuta una vez al montar y,
    si Google devuelve un token, se habilita el botón "Continue". El token no
    se envía al backend (no hay verificación server-side de score todavía). */
    useEffect(() => {
        getRecaptchaV3Token(CONFIG_SETTINGS.GOOGLE_RECAPTCHA_KEY, 'registration')
            .then(token => { if (token) setValidCaptcha(true) })
            .catch(err => console.log('reCAPTCHA v3 error', err))
    }, [])



    const actions = {
        /**
         * @function  
         * @description The code is defining an `onUpdateView` function that takes a parameter `_view` and
         * sets the state of `view` to the value of `_view` using the `setView` function. This code is
         * likely part of a React component and is used to update the view based on some user
         * interaction or other event. 
         * @param _view - Value of the view to update
         * 
        */
        onUpdateView: function(_view){
            setView(_view)
        },
        /* The code is defining a function called `onResetForm` which resets the registration
        form to its initial state. It sets the view to the phone number request step, sets the form
        data to its initial state, clears any error messages, and sets the sending flag to false. */
        onResetForm: () => {
            setView(REGISTRATION_STEPS.PHONENUMBER_REQUEST)
            setForm(JSON.parse(JSON.stringify(form_data)))
            setError(null)
            setSending(false)
        },
        /* The code defines an asynchronous function called `onGetCardholerInfo` that sends a GET
        request to an endpoint `/info` on a server using Axios library. The request includes a
        parameter `transactionUuid` with a value generated by calling the `uuid()` function. The
        function then waits for the response from the server and assigns the response data to a
        variable called `info`. Finally, the function returns the `info` variable. */
        onGetCardholerInfo: async() => {
            const user_rq = await onboarding_server.get('/info', {params:{transactionUuid:uuid()}})
            const info = user_rq.data
            return info
        },
        /* The code is an asynchronous function that is executed when a module is initialized. It
        first waits for 1 second using the `sleep` function. Then it parses the query parameters
        from the current URL using the `qs` library. If a `uuid` parameter is present, it sets the
        `CasinoUUID` state variable to its value and sends a validation request to the server using
        the `onboarding_server` object. If a `playerId` parameter is present, it sets the `PlayerID`
        state variable to its value. If any error occurs during this process, it updates the */
        onInitModule: async() => {
            try {
                await sleep(1000)
                const args = qs.parse(location.search)
                if(args?.uuid){
                    setCasinoUUID(args?.uuid)

                    console.log('Start uuid validation')
                    const params = {
                        programUuid:args?.uuid,
                        transactionUuid: uuid()
                    }
                    //console.log('Validate with ', params)
                    const request = await onboarding_server.get('/program', {params:params})
                    //console.log(request.data)


                }else{
                    actions.onUpdateModalStatus('uuid_error', true)
                }

                if(args?.playerId){
                    setPlayerID(args.playerId)
                }

            } catch (error) {
                console.log(error)
                actions.onUpdateModalStatus('uuid_error', true)
            }
        },
        /* The code is defining an `onUpdateCode` function that takes in a parameter `_data`.
        Within the function, it sets the state of `phoneCode` to the value of `_data` using the
        `setPhoneCode` function. It also sets the `error` state to `null` using the `setError`
        function. This code is likely part of a React component and is used to update the state of
        the component when a user enters or updates a phone code value. */
        onUpdateCode: (_data) => {
            setPhoneCode(_data)
            setError(null)
        },
        /* The code is defining a function called `onUpdateAgreement` that takes in three
        parameters: `data`, `pos`, and `type`. */
        onUpdateAgreement: (data, pos, type) => {
            if(type === 'view'){
                setDocument(data)
                actions.onUpdateModalStatus('document', true)
            }
            
            let _agreements = [...agreementCollections]
            _agreements[pos] = {...data}
            setAgreementCollections(_agreements)
            setSending(false)
            setError(null)
        },
        onUpdateCard: async(id, data) => {

        },
        
        /* The code is a function that handles the onChange event of a form input field. It
        updates the state of the form based on the user input and performs some validations on
        specific fields such as the social security number, zip code, phone number, and birth date.
        It also sets the loading and sending states to false and updates the form state with the new
        data. */
        onChangeForm: (data) => {
            setLoading(false)
            setSending(false)
            if(typeof data.value === 'string'){
                //data.value = data.value.toUpperCase()
                //console.log('es estirng', data.value)
            }
            

            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            
            if(id === 'ssn'){
                const pattern = /^[0-9]*$/
                if(!data.value.match(pattern)) return
                temp[id] = { ...data }
            }else{
                temp[id] = { ...data }
            }
            
            
            if(id === 'zip_code'){
                const zipinfo = actions.onSearchAddressInfo(data.value)
                if(zipinfo){
                    temp.city.value = zipinfo.city
                    temp.city.isValid = true
                    temp.city.isVisited = true
                    temp.state.value = zipinfo.state_name
                    temp.state.isValid = true
                    temp.state.isVisited = true
                    temp.city.code = zipinfo.state_id
                }else{
                    temp.city.value = ''
                    temp.city.isValid = false
                    temp.state.value = ''
                    temp.state.isValid = false
                    temp.zip_code.isValid = false
                    temp.zip_code.helperText = 'Zip code not found'
                }
            }
            
            if(id === 'cell_phone_number' || id === 'country_code_area' ){
                temp[id] = { ...data }
                const countryCode = temp.country_code_area.value
                const number = temp.cell_phone_number.value
                const countryData = phoneCountryCodesCat.find(el => el.value === countryCode)
                const phonenumber = `${countryCode??''}${number??''}`
                
                const phonevalidation =  parsePhoneNumber(phonenumber, countryData?.countryCode)
                if(phonevalidation){
                    const isValidPhone = phonevalidation.isValid()
                    //console.log(phonenumber, isValidPhone)
                    if(temp.cell_phone_number.isVisited){

                        temp.cell_phone_number.isValid = isValidPhone
                    }
                }
            }
            if(id === 'birth_date'){
                //console.log('Birth date evaluation', maxAge)
                if(data.isValid){
                    //console.log(data.value)
                    let birthData = moment(data.value)
                    //const diff = birthData.diff(moment().subtract(maxAge,'year'))
                    const diff = moment().diff(birthData,'year')
                    //console.log(diff)
                    if(diff < maxAge){
                        //console.log('Negar esto')
                        temp[id].isValid = false
                        temp[id].config.helperText = `Your ages must be at least ${maxAge} years old`
                    }
                    //if(birthData.diff(moment().subtract(18,'year')))
                }
                
            }
            if(error) setError(null)
            //console.log(temp.birth_date)
            setForm(temp)
        },
        /* The code is defining an event handler function for the `onKeyPress` event in a React
        component. When a key is pressed, the function checks if the key pressed is the "Enter" key.
        If it is, the `onSubmit` function is called. This is commonly used in forms to submit the
        form when the user presses the "Enter" key. */
        onKeyPress: (event) => {
            if(event.key === 'Enter'){
              actions.onSubmit()
            }
        },
        /* The code is defining a function called `onSearchAddressInfo` that takes a parameter
        `zip`. The function searches for an object in an array called `zipcodeCats` that has a
        property `zip` equal to the `zip` parameter passed to the function. If a matching object is
        found, it is returned. If not, `undefined` is returned. The `uszipcodes` object is optional
        and if it is not defined, an empty array is used as a fallback. The commented out
        `console.log` statement is used for debugging purposes. */
        onSearchAddressInfo: (zip) => {
            const zipcodeCats =  uszipcodes?.uszipcodes??[]
            //console.log(JSON.stringify(zipcodeCats))
            const el = zipcodeCats.find(el => el.zip == zip);
            return el
        },
        ////////////////////////////////  PHONE NUMBER VIEW  ///////////////////////////////////////////////
        /* The code is a JavaScript React function called `onSendSMSv2` that sends an SMS access
        code to a given phone number. It first gets the form data and constructs a payload object
        with the phone number and a unique transaction UUID. It then sends a POST request to an API
        endpoint with the payload and API key headers. If the response status is 400 or 404, it sets
        an error message and stops sending. If the response status is 0, it sets the view to a SMS
        request step. Finally, it sets the sending state to false. */
        onSendSMSv2: async() => {

            const data2send = onGetFormData(form)
            const phonenumber = `${data2send.country_code_area??''}${data2send.cell_phone_number??''}`
            
            
            
            let payload = {
                transactionUuid: uuid(),
                cellPhoneNumber:phonenumber,
                "programUuid": casino_uuid
            }
            setSending(true)
            //console.log('Send code to validate cardholder', payload)
            try {
                // First we need to check info to see if something is already available
                //const logData = localStorage.getItem('session');
                const response = await fetch(`${CONFIG_SETTINGS.ONBOARDING_URL}/sms/accessCode`, {
                    method:'POST',
                    headers:{
                        'Content-Type': 'application/json',
                        'x-api-key': CONFIG_SETTINGS.ONBOARDING_APIKEY
                    },
                    body:JSON.stringify(payload)
                })

                console.log(response)
                
                if(response.status === 400 || response.status === 404){
                    const finalresponse = await response.json();
                    setError(finalresponse?.message)
                    setSending(false)
                    return
                }else if(response.status === 200 || response.status === 0){
                    if(view !== REGISTRATION_STEPS.SMS_REQUEST) setView(REGISTRATION_STEPS.SMS_REQUEST)
                }
                
                
            } catch (error) {
              console.log(error)  
            }
            setSending(false)
            
        },  
        /* The code is defining an asynchronous function called `onRequestUserData` that sends a
        request to an onboarding server to retrieve user information. If the user has cardholder
        data, the function extracts relevant information such as name, address, email, and social
        security number, and initializes a form with this information. The function also sets the
        maximum age for the user based on constraints specified in the user's enrollment data.
        Finally, the function returns the user information. */
        onRequestUserData: async() => {
            const user_rq = await onboarding_server.get('/info', {params:{transactionUuid:uuid()}})
            const info = user_rq.data

            //console.log(info)
            
            //Check if there id cardholder data
            if(info?.enrollment?.cardholder){

                const {cardholder} = info?.enrollment

                const zipinfo = actions.onSearchAddressInfo(cardholder?.address?.zipCode)
                //console.log('ZIP INFO',zipinfo)
                let origin = {
                    birth_date:cardholder.dateOfBirth,
                    first_name:cardholder.firstName,
                    surname:cardholder.lastName,
                    street_line_one:cardholder?.address?.line1,
                    street_line_two:cardholder?.address?.line2,
                    zip_code:cardholder?.address?.zipCode,
                    city:zipinfo?.city??null,
                    state:zipinfo?.state_name??null,
                    email:cardholder?.email,
                    ssn:cardholder?.ssn,
                    sex_id:cardholder?.gender,
                }
                //console.log('On Init Form')
                let _form = onInitFormFromOrigin(form, origin)
                //console.log('On End Form', _form)
                
                setForm(_form)
                
            }
            let _age = maxAge
            //console.log('Mi edad', _age)
            if(info?.enrollment?.constraints){
                const cardMinAge = info?.enrollment?.constraints?.cardMinAge
                const gamblingMinAge = info?.enrollment?.constraints?.gamblingMinAge

                _age = cardMinAge > gamblingMinAge ? cardMinAge : gamblingMinAge

               // console.log(info?.enrollment?.constraints, _age)

            }
            setMaxAge(_age)
            return info
        },
        ////////////////////////////////  SMS VIEW  ///////////////////////////////////////////////
        /* The code is a function in JavaScript React that is used to validate a SMS code entered
        by a user during a registration process. It sends a request to a server with the user's
        phone number and the code entered, and if the code is valid, it proceeds to the next step of
        the registration process. The function also checks if the user has already enrolled, if
        there is a pin validation required, if there are agreements that need to be accepted, and
        sets the next view accordingly. If there is an error, it sets an error message and prompts
        the user to try again. */
        onValidateSMSCodev2: async() => {
            setSending(true)
            setError(null)
            const data2send = onGetFormData(form)
            const phonenumber = `${data2send.country_code_area??''}${data2send.cell_phone_number??''}`
            let payload = {
                programUuid: casino_uuid,
                transactionUuid:uuid(),
                cellPhoneNumber:phonenumber,
                code: phoneCode
            }
            let next_view = REGISTRATION_STEPS.TERMS_CONDITION

            try {
                // Validate code data
                removeAuthorizationHeader(onboarding_server)
                const response = await onboarding_server.post('/sms/accessCode/auth', payload)
                const data2save = response.data
                login(data2save?.token)

                await sleep(500)

                const info = await actions.onRequestUserData()

                // Check if there is already enrolled
                if(info?.enrollment?.enrolled){
                    next_view = REGISTRATION_STEPS.SUCCESS
                    setSending(false)
                    setView(next_view)
                    return
                }

                // CHECK IF there is a pin validation for an specific casino
                if(info?.enrollment?.constraints?.accountValidationRequired ||
                    info?.enrollment?.constraints?.pinValidationRequired ||
                    info?.enrollment?.constraints?.challengeRequired
                ){
                    next_view = REGISTRATION_STEPS.CASINO_PIN
                    setSending(false)
                    setView(next_view)
                    return
                }

                if(info?.enrollment?.cardholder){
                    next_view = REGISTRATION_STEPS.USER_FORM
                    setSending(false)
                    setView(next_view)
                    return
                }
                
                // CHECK IF THERE IS AGREEMENTS
                if(info?.agreement?.accepted){
                    next_view = REGISTRATION_STEPS.USER_FORM // MUST BE USER FORM
                    setSending(false)
                    setView(next_view)
                    return
                }

                

            } catch (error) {
                console.log(error)
                setPhoneCode('')
                setError(error?.message ?? 'There was an error, please try again')
                setSending(false)
                return
            }
            setSending(false)
            setView(next_view)
            //console.log(payload)

        },
        /* The code is defining an asynchronous function called `onRequestDocuments` that sends a
        GET request to an endpoint `/cat/agreement` on a server using the `onboarding_server`
        object. The function takes no arguments. The request includes a query parameter
        `transactionUuid` with a value generated by calling the `uuid()` function. */
        onRequestDocuments: async() => {
            setLoading(true)
            try {
                const response = await onboarding_server.get('/cat/agreement', {params:{transactionUuid:uuid()}})
                setAgreementCollections(response?.data?.agreements??[])
                setIssuerStatement(response?.data?.issuerStatement)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        },
        ////////////////////////////////  TERMS AND CONDITIONS VIEW  ///////////////////////////////////////////////
        /* The code is defining an asynchronous function called `onValidateDocuments`. This
        function is used to validate and send agreements for a cardholder. */
        onValidateDocuments: async() => {

            //actions.onRequestDocuments()
            //return
            setSending(true)
            let isValid = true
            let agreements2send = []
            agreementCollections.forEach(item => {
                if(!item.accepted){
                    isValid = false
                }else{
                    agreements2send.push({
                        id:item.id,
                        version:item.version
                    })
                }
            })

            if(!isValid){
                setSending(false)
                setError('Please review and accept all the documents')
                return
            }
            let data2send = onGetFormData(form)
            const phonenumber = `${data2send.country_code_area??''}${data2send.cell_phone_number??''}`


            const payload = {
                transactionUuid:uuid(),
                agreements: agreements2send
            }

            try {
                // Validate code data
                const response = await onboarding_server.post('/cardholder/agreement', payload)
                
            } catch (error) {
                console.log(error)
                setSending(false)
                setError(error?.message ?? 'Unable to update agreements, please try again')
                return 
            }
            setSending(false)
            setView(REGISTRATION_STEPS.USER_FORM)
        },
       /* The code is a JavaScript React function that handles the process of checking and
       validating an address form. It first checks if all required fields are filled, and if not, it
       sets an error message and returns. If the required fields are filled, it checks if the
       address contains "PO BOX" or "P.O. BOX", and if it does, it sets an error message and
       returns. If the address is valid, it sends a GET request to a server API endpoint with the
       address information, and if the response is successful, it sets the retrieved address data to
       a state variable and updates the */
        onCheckAddress: async() => {

            const _errors = isFormValid(form, ['street_line_one', 'zip_code', 'city', 'state',
             'first_name', 'surname', 'birth_date', 'ssn', 'email', 'sex_id'])
            //console.log(_errors)

            if(_errors && _errors.length){
                console.log(_errors)
                const _form = onSetErrorsToForm(form, _errors)
                setError('Required fields are missing')
                setForm(_form)
                //setError(generic_errors[language].INCOMPLETE_FORM)
                return
            }

            const data2send = onGetFormData(form, ['street_line_one', 'street_line_two', 'zip_code', 'city', 'state'])

            if(data2send.street_line_one){
                const temp = data2send.street_line_one.toUpperCase()
                let invalid = temp.includes('PO BOX') || temp.includes('P.O. BOX')
                if(invalid){
                    setError('PO BOX and P.O. BOX are not allowed in address information ')
                    return
                }
            }

            setSending(true)
            //console.log(data2send)
            const zipcodeCats =  uszipcodes?.uszipcodes??[]
            const stateEl = zipcodeCats.find(el => el.state_name === data2send.state) 

            const params = {
                street: data2send.street_line_one,
                //secondary: data2send.street_line_two,
                city:data2send.city,
                state: 'DSAFA' || (stateEl?.state_id??''),
                zipcode:data2send.zip_code
            }


            //console.log(params)

             


            try{
                // En modo proxy la key va vacía (la inyecta la Function server-side),
                // así que solo se setea el header cuando hay key local (dev).
                if (CONFIG_SETTINGS.API_APIKEY) {
                    services_server.defaults.headers.common['x-api-key'] = CONFIG_SETTINGS.API_APIKEY;
                }
                const response = await services_server.get('/smarty/streetAddress', {params:{...params}})
                console.log(response)
                if(response.status === 400 || response.status === 404){
                    setError(response?.message ?? 'We could not validate your address data')
                    setSending(false)
                    return
                }else{
                    setSmartyAddresses(response.data.data)
                    actions.onUpdateModalStatus('address_adjustment', true)
                    setError(null)
                }
                //setSmartyAddresses(response.data.data)
                //actions.onUpdateModalStatus('address_adjustment', true)
            }catch(e){
                console.log(e?.response?.data?.message)
                setError(e?.response?.data?.message ?? "There was an error, please try again.")
                setSending(false)
                return
            }

            setSending(false)
        },
        /* The code is a function called `onEnrollCardholder` that is being defined in JavaScript
        React. It's main purpose is to enroll a new cardholder to the corresponding program, and if the
        server response throws an error, this function handles the error to show the end user the reason
        of rejection or if an error exist during the process. */
        onEnrollCardholder: async(smartyAddress) => {

            const errors = isFormValid(form)

            if(errors && errors.length){
                console.log(errors)
                const _form = onSetErrorsToForm(form, errors)
                setError('Required fields are missing')
                setForm(_form)
                actions.onUpdateModalStatus('address_adjustment', false)
                return
            }

            const data2send = onGetFormData(form)
            const phonenumber = `${data2send.country_code_area??''}${data2send.cell_phone_number??''}`

            setSending(true)

            const _birthdate = data2send.birth_date
            let deviceIP = '192.168.0.10'
            try {
                const response = await axios.get('https://geolocation-db.com/json/')
                deviceIP = response.data.IPv4
                console.log(response.data.IPv4)
            } catch (error) {
                
            }

            let primaryline = smartyAddress?.delivery_line_1??''
            primaryline = primaryline
            .toUpperCase()
            .replace('# ','')
            .replace('#','')
            
            // country code : 840
            let obj2send = {
                deviceCounter: 0,
                transactionUuid:uuid(),
                programUuid: casino_uuid,
                cellPhoneNumber: phonenumber,
                "firstName": (data2send.first_name??'').toUpperCase(),
                "middleName": (data2send.middle_name??'').toUpperCase(),
                "lastName": (data2send.surname??'').toUpperCase(),
                "dateOfBirth": _birthdate,
                "gender": data2send.sex_id??'',
                "ssn": data2send.ssn??'',
                "email": data2send.email??'',
                "address": {
                    "line1": primaryline,
                    "line2": '',
                    "city": smartyAddress?.components?.city_name.toUpperCase(),
                    "stateCode": smartyAddress?.components?.state_abbreviation,
                    "state": (data2send?.state?? '').toUpperCase(),
                    "countryCode": 840,
                    "zipCode": smartyAddress?.components?.zipcode,
                },
                cardholderIp:deviceIP,
                playerId: playerID??undefined
            }
            //console.log(smartyAddress)
            //console.log(obj2send)
            //setSending(false)
            //return
            setSending(true)

            try {
                // Validate code data
                //console.log(obj2send)
                const response = await onboarding_server.post('/cardholder/enroll', obj2send)
                //console.log(encryptedData)
                console.log(response.data)
                actions.onUpdateModalStatus('address_adjustment', false)
                setSending(false)
                setView(REGISTRATION_STEPS.SUCCESS)
                //setView(1000)
            } catch (error) {
                setError(error?.message)
                actions.onUpdateModalStatus('address_adjustment', false)

                setSending(false)
                //setView(REGISTRATION_STEPS.SUCCESS)
                return
            }
            setSending(false)
            setView(REGISTRATION_STEPS.SUCCESS)

            setSending(false)
        },
        /* The code is defining a function called `onResetError` that sets the value of the
        `error` variable to `null`. This function is likely used to reset or clear any error
        messages that may have been previously displayed. */
        onResetError: () => {
            setError(null)
        },
        /* The code is defining an arrow function called `onUpdateModalStatus` that takes two parameters
        `_key` and `_value`. Inside the function, it is using the `setModals` function to update the state
        of the `modals` object. The `setModals` function is a state updater function provided by React's
        `useState` hook. It takes an object as an argument and merges it with the current state of the
        `modals` object. The object being merged is created using the spread operator (`...`) to copy the
        existing properties of the `modals` object */
        onUpdateModalStatus: (_key, _value) => setModals({...modals, [_key]:_value}),
    }

    const system = {loading, sending, error}
    const data = {view, steps, phoneCode,
        agreementCollections, issuer_statement,
        smartyAddresses, valid_captcha, document}

    return {
        system, data, actions, form, modals, authManager
    }


}



export default useRegistration





const form_data = {
    first_name:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'first_name',
            type:'text',
            fullWidth: true,
            label:'First name',
            placeholder:'First name',
            helperText:'First name requieres at most 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
    surname:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'surname',
            type:'text',
            fullWidth: true,
            label:'Last Name',
            placeholder:'Last Name',
            helperText:'Last Name requieres at most 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
    email:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'email',
            type:'email',
            fullWidth: true,
            label:'Email',
            placeholder:'Email',
            helperText:'Invalid email'
        },
        rules:{
            type:'email',
        }
    },
    country_code_area:{
        value: '1',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        options:phoneCountryCodesCat,
        config:{
            id:'country_code_area',
            type:'select',
            fullWidth: true,
            label:'',
            placeholder:'',
            helperText:'Invalid code number',
        },
        rules:{
            type:'select',
        }
    },
    sex_id:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[
            { label: "Male", value: "M", },
            { label: "Female", value: "F", },
        ],
        config:{
            id:'sex_id',
            type:'select',
            fullWidth: true,
            label:'Gender',
            placeholder:'Gender',
            helperText:'Invalid gender value',
        },
        rules:{
            type:'select',
        }
    },
    cell_phone_number:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'cell_phone_number',
            type:'tel',
            fullWidth: true,
            label:'Phone Number',
            placeholder:'Cellphone',
            helperText:'Mobile must be a valid phone number'
        },
        rules:{
            type:'none'
        }
    },
    alt_country_code_area:{
        value: '+1',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        options:[
            { label: "+1", value: "+1", img: usaFlag},
            { label: "+52", value: "+52", img: mexicoFlag},
        ],
        config:{
            id:'alt_country_code_area',
            type:'select',
            fullWidth: true,
            label:'',
            placeholder:'',
            helperText:'Invalid code number',
        },
        rules:{
            type:'select',
        }
    },
    phone_number:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'phone_number',
            type:'tel',
            fullWidth: true,
            label:'Alternative Phone Number',
            placeholder:'Home, Office, etc',
            helperText:'Mobile must be a valid phone number'
        },
        rules:{
            type:'phone_number'
        }
    },
    birth_date:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'birth_date',
            type:'date',
            fullWidth: true,
            label:'Date of birth',
            placeholder:'Date of birth',
            helperText:'Date of birth must be a valid date'
        },
        rules:{
            type:'date'
        }
    },
    ssn:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'ssn',
            type:'password',
            
            fullWidth: true,
            label:'SSN',
            placeholder:'9 digits no hyphens',
            helperText:'Invalid SSN '
        },
        rules:{
            type:'ssn'
        }
    },
    street_line_one:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'street_line_one',
            type:'text',
            fullWidth: true,
            label:'Address line',
            placeholder:'NUMBER, STREET, APARTMENT (BUILDING, FLOOR, UNIT, ROOM, ETC)',
            helperText:'Address Line must be a value between 1 to 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
    street_line_two:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'street_line_two',
            type:'text',
            fullWidth: true,
            label:'Address line 2',
            placeholder:'Additional information',
            helperText:'Address Line 2 must be a value between 1 to 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
    zip_code:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'zip_code',
            type:'number',
            fullWidth: true,
            label:'Zip Code',
            placeholder:'XXXXX',
            helperText:'Invalid Zip code '
        },
        rules:{
            type:'distance', min:0, max:5
        }
    },
    city:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        //disabled:true,
        config:{
            id:'city',
            type:'text',
            fullWidth: true,
            label:'City',
            placeholder:'City',
            //helperText:'City must be a value between 1 and 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
    state:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        //disabled:true,
        config:{
            id:'state',
            type:'text',
            fullWidth: true,
            label:'State',
            placeholder:'State',
            //helperText:'State must be a value between 1 and 256 characters, not special characters are allowed, only alphanumeric and dots'
        },
        rules:{
            type:'basic_chars', min:0, max:256
        }
    },
}

const fakeAddresses = [
    {
        "input_index": 0,
        "candidate_index": 0,
        "delivery_line_1": "5 Covent Pl",
        "last_line": "Hartsdale NY 10530-2947",
        "components": {
            "primary_number": "5",
            "street_name": "Covent",
            "street_suffix": "Pl",
            "city_name": "Hartsdale",
            "default_city_name": "Hartsdale",
            "state_abbreviation": "NY",
            "zipcode": "10530",
            "plus4_code": "2947",
            "delivery_point": "05",
            "delivery_point_check_digit": "4"
        },
        "metadata": {
            "record_type": "S",
            "zip_type": "Standard",
            "county_fips": "36119",
            "county_name": "Westchester",
            "latitude": 41.02261,
            "longitude": -73.82823,
            "precision": "Zip9",
            "time_zone": "Eastern",
            "utc_offset": -5,
            "dst": true
        },
        "analysis": {
            "dpv_match_code": "Y",
            "dpv_footnotes": "AABB",
            "dpv_cmra": "N",
            "dpv_vacant": "N",
            "dpv_no_stat": "N",
            "active": "Y",
            "footnotes": "N#"
        }
    },
    {
        "input_index": 1,
        "candidate_index": 1,
        "delivery_line_1": "25 Covent Pl",
        "last_line": "Hartsdale NY 10435-2947",
        "components": {
            "primary_number": "5",
            "street_name": "Covent",
            "street_suffix": "Pl",
            "city_name": "Hartsdale",
            "default_city_name": "Hartsdale",
            "state_abbreviation": "NY",
            "zipcode": "10530",
            "plus4_code": "2947",
            "delivery_point": "05",
            "delivery_point_check_digit": "4"
        },
        "metadata": {
            "record_type": "S",
            "zip_type": "Standard",
            "county_fips": "36119",
            "county_name": "Westchester",
            "latitude": 41.02261,
            "longitude": -73.82823,
            "precision": "Zip9",
            "time_zone": "Eastern",
            "utc_offset": -5,
            "dst": true
        },
        "analysis": {
            "dpv_match_code": "Y",
            "dpv_footnotes": "AABB",
            "dpv_cmra": "N",
            "dpv_vacant": "N",
            "dpv_no_stat": "N",
            "active": "Y",
            "footnotes": "N#"
        }
    }
]